// extracted by mini-css-extract-plugin
export default {"sideBar":"SideBarAboutUsInfo_sideBar__A-lFC"};